import React, {useState} from 'react';
import {Form, Input, Checkbox, Button, Radio, Switch, Select} from 'antd';
import styles from './layout.module.less'
import NumberInput from "../../../components/NumberInput";
import store from "../store";
import projectStore from "../../user/project/store";
import {observer} from 'mobx-react';
// import moment from "moment";
import lodash from 'lodash'


// the hook
import {useTranslation} from 'react-i18next';

export default observer(function (props) {
  const {t, i18n} = useTranslation();
  const {record, index} = props
  const {selectedCustomKeys} = store
  const [formRef] = useState(React.createRef())
  const [isMeasure, setIsMeasure] = useState(record['is_measure'])
  const [uid] = useState((new Date()).getTime() + Math.random())

  console.log(index)
  const delRow = () => {
    if (record.id) {
      store.delRecord(record.id, index, true)
    } else {
      store.userAddRecords.splice(index, 1)
    }
  }

  const onRadioClick = () => {
    formRef.current.setFieldsValue({
      is_measure: !isMeasure,
    });
    setIsMeasure(!isMeasure)
  }

  const onFinish = (data) => {
    data.isEdit = false
    data.catalog = data.catalog ? "Sale" : "Rent"
    store.updateUserAddRecord(data, index)
  }

  // const disabledDate = (current) => {
  //   return current < moment().subtract(1, 'days')
  // }

  const handleCheck = (e, id) => {
    if (e.target.checked && selectedCustomKeys.indexOf(id) === -1) {
      selectedCustomKeys.push(id)
    }
    if (!e.target.checked) {
      lodash.remove(selectedCustomKeys, v => v === id)
    }
  }

  return (
    <React.Fragment>
      <Form className={[styles.formRow, 'reset-disabled-input', styles.formRowEdit].join(" ")}
            key={record.id ? record.id : uid}
            initialValues={record}
            name={record.id ? record.id : uid}
            layout="inline"
            ref={formRef}
            onFinish={data => onFinish(data)}>

        <Form.Item valuePropName="checked" name='checked' className={styles.td1}>
          <Checkbox disabled={!record.id} onChange={(e) => {
            handleCheck(e, record.id)
          }}/>
        </Form.Item>

        <Form.Item valuePropName="checked" name="catalog"
                   className={[styles.td2, i18n.language === 'en' ? styles.autoWidth : ''].join(" ")}>
          <Switch checkedChildren={t("购")} unCheckedChildren={t("租")} defaultChecked={true}/>
        </Form.Item>

        <Form.Item name="name" className={styles.td3} rules={[{required: true, message: t('请输入')}]}>
          <Input placeholder={t('产品品名')}/>
        </Form.Item>

        <Form.Item name="brand" className={styles.td4} rules={[{required: true, message: t('请输入')}]}>
          <Input placeholder={t('品牌')}/>
        </Form.Item>

        <Form.Item name="formats" className={styles.td5}>
          <Input placeholder={t('规格')}/>
        </Form.Item>

        <Form.Item name="factoryCode" className={styles.td6} rules={[{required: true, message: t('请输入')}]}>
          <Input placeholder={t('货号')}/>
        </Form.Item>

        <Form.Item name="desc" className={styles.td7}>
          <Input placeholder={t('产品说明')}/>
        </Form.Item>

        <Form.Item name="number" className={styles.td8}>
          <NumberInput size='small' min={1} max={999}/>
        </Form.Item>

        {/* <Form.Item name="extra_sn" className={styles.td9}>
          <Select placeholder={t('项目编号')} allowClear={true}
                  style={{width: "0.71875rem", textAlign: "center", margin: '0 0.104rem'}}>
            {
              projectStore.records.map(item => (
                <Select.Option key={item.id} value={item.id + ''}>
                  <span title={item.name + '[' + item.sn + ']'}>{item.name}[{item.sn}]</span>
                </Select.Option>
              ))
            }
          </Select>
        </Form.Item> */}

        {/*  <Form.Item name="delivery_date" className={styles.td10}>
            <DatePicker className={styles.date}
                        disabledDate={disabledDate} placeholder='请选择日期' style={{width: 130}}/>
          </Form.Item>*/}

        {/* <Form.Item name="is_measure" className={styles.td11}>
          <Radio.Group>
            <Radio onClick={() => {
              onRadioClick(index)
            }} value={true}/>
          </Radio.Group>
        </Form.Item> */}

        <div style={{flex: 1}}/>

        <Form.Item hidden={true} name="id">
          <Input/>
        </Form.Item>
        <Form.Item className={styles.td12}>
          <div className={styles.rowBtn}>
            <Button size={'small'} type={'primary'} htmlType="submit">{t('保存')}</Button>
            {
              record.id ?
                <Button size={'small'} onClick={() => record.isEdit = false} style={{marginLeft: '0.0260rem'}}>{t('取消')}</Button>
                :
                <span onClick={() => delRow()} className={['icon icon-del', styles.del].join(" ")}/>
            }

          </div>

        </Form.Item>
      </Form>
    </React.Fragment>
  )
})
